"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutAlphavision() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: col1Ref,
    isVisible: col1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: col2Ref,
    isVisible: col2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about-alphavision" className="w-full bg-light-background py-16 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 ref={titleRef} className={`text-3xl md:text-4xl font-bold text-foreground-light text-center mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>About Alphavision Communication</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-8">
          <div ref={col1Ref} className={`flex flex-col gap-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-100 ${col1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <p className="text-base text-foreground-light leading-relaxed">
              Alphavision is a professional audio-visual solution provider dedicated to transforming how businesses and institutions communicate through cutting-edge display technology. Our team of audio-visual experts brings together years of experience and a shared passion for innovation.
            </p>
            <p className="text-base text-foreground-light leading-relaxed">
              We specialize in creating immersive visual experiences that enhance engagement, improve information delivery, and elevate brand presence. From corporate environments to educational institutions, our solutions are designed to meet the evolving needs of modern communication.
            </p>
            <p className="text-base text-foreground-light leading-relaxed">
              Our commitment to excellence drives us to stay at the forefront of display and information technology, ensuring that our clients benefit from the latest advancements in the industry.
            </p>
          </div>

          <div ref={col2Ref} className={`flex flex-col gap-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-200 ${col2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <p className="text-base text-foreground-light leading-relaxed">
              With a focus on reliability and innovation, we deliver comprehensive solutions that include LED Wall displays, Digital Signage systems, and Education Interactive Touch Screens. Each solution is tailored to meet specific client needs while maintaining the highest standards of quality.
            </p>
            <p className="text-base text-foreground-light leading-relaxed">
              Our approach combines technical expertise with a deep understanding of user experience, ensuring that every installation not only meets functional requirements but also creates lasting impressions.
            </p>
            <p className="text-base text-foreground-light leading-relaxed">
              At Alphavision, we believe that better display technology leads to better communication, better learning, and ultimately, a better life. This philosophy guides everything we do, from initial consultation to ongoing support.
            </p>
          </div>
        </div>
      </div>
    </section>;
}